/** @jsx jsx */

import { jsx } from '@emotion/core';
import ReactMaskedInput, { MaskedInputProps } from 'react-text-mask';
import { InputBaseComponentProps } from '@material-ui/core/InputBase';

/**
 * Same as MaskedInputProps but does not include props for HTML input (not needed
 * because we are using Mui's TextField)
 */
export type MaskedProps = Pick<
  MaskedInputProps,
  | 'mask'
  | 'guide'
  | 'placeholderChar'
  | 'keepCharPositions'
  | 'pipe'
  | 'showMask'
>;

/**
 * Prop names for MaskedInput.
 *
 * TypeScript does not intend to support reflection, so there is no way to
 * avoid the repetition here.
 */
export const propNames = [
  'mask',
  'guide',
  'placeholderChar',
  'keepCharPositions',
  'pipe',
  'showMask',
];

/**
 * MaskedInput that works as custom Input component for MUI.
 * There's unlikely to be any reasons to use this component by itself.
 *
 * Example:
 * ```
 * <MuiTextField
 *  {...otherProps}
 *  InputProps={{
 *    inputComponent: MaskedInput,
 *    inputProps: {
 *       mask: [/\d/, /\d/, /\d/]
 *    }
 *  }}
 * />
 * ```
 */
export const MaskedInput: React.FC<
  InputBaseComponentProps & MaskedProps
> = props => {
  const { inputRef, ...other } = props;

  return (
    <ReactMaskedInput
      {...other}
      ref={ref => inputRef(ref ? ref.inputElement : null)}
    />
  );
};

export default MaskedInput;
